<template>
  <el-dialog
    :visible.sync="visible"
    append-to-body
    :show-close="true"
    :center="true"
    :before-close="handleClose"
    title="提交立项"
    width="500px"
  >
    <div>
      <el-form ref="form" :model="formData"  :rules="rules" label-width="120px">
       

        <el-form-item label="项目名称" prop="name" >  
          <el-input  type="text" v-model="formData.name"  ></el-input> 
        </el-form-item>

        <el-form-item label="选择企业" prop="company_app_id">
            <el-select
                  v-model="formData.company_app_id"
                  clearable
                  filterable
                  placeholder="请选择"
                  style="width:100%"
                >
                <el-option
                  v-for="item in companyList"
                  :key="item.company_app_id"
                  :label="item.company_name"
                  :value="item.company_app_id"
                />
          </el-select>
        </el-form-item>

        <el-form-item label="项目头像	" prop="image" >
          <imageUpload v-model="formData.image"/>

        </el-form-item>


        <el-form-item label="项目开始日期" prop="start_at" >
          <el-date-picker
              v-model="formData.start_at	"
              type="date"
              placeholder="选择日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd">
            </el-date-picker>
        </el-form-item>

        <el-form-item label="项目结束日期" prop="end_at" >
          <el-date-picker
              v-model="formData.end_at	"
              type="date"
              placeholder="选择日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              >
            </el-date-picker>
        </el-form-item>

        

        <el-form-item label="项目描述">
          <el-input type="textarea" v-model="formData.description"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submit">确 定</el-button>

      <el-button @click="visible = false">取 消</el-button>
    </span>


  </el-dialog>
</template>

<script>
import { addProject,projectList,companyList,updateProject,projectInfo} from "@/api/director/project/index";

import FileUpload from '@/components/FileUpload';
import ImageUpload from '@/components/ImageUpload';

export default {
  components: {
    FileUpload,ImageUpload
  },

  data() {
    return {

      visible: false,
      companyList:[],
      formData: {
        project_id:"",
        name:"",
        image: "",
        start_at: "",
        end_at: "",
        description: "",
        company_app_id:"",
      },
       rules: {
          name: [
              {required: true, message: '请输入项目名称', trigger: 'blur'}
          ],
          image: [
              {required: true, message: '请上传项目头像', trigger: 'blur'}
          ],

          start_at: [
              {required: true, message: '请选择项目开始日期', trigger: 'blur'}
          ],

          end_at: [
              {required: true, message: '请选择项目结束日期', trigger: 'blur'}
          ],

          description: [
              {required: true, message: '请填写项目描述', trigger: 'blur'}
          ],

          company_app_id	: [
              {required: true, message: '请选择企业', trigger: 'blur'}
          ]

          

       }
    };
  },

 
  mounted() {
    console.log("asdasdasd")
    this.initCompanyList();

},
  
  methods: {
    handleClose() {
      this.visible = false;
      this.$refs["form"].resetFields();

    },


    init(data) {
      console.log(data);
     
      if(data&&data.project_id){
        this.formData.project_id=data.project_id;
        this.initProject();
      }  
     
      this.visible = true;
      
    },

    initCompanyList(){
      var that = this;
      companyList({}).then((response) => {
        console.log('companyList',response);
        that.companyList = response.data;
      });
    },

    initProject(){
      var that = this;
      projectInfo({project_id:that.formData.project_id}).then((response) => {
        var info = response.data;
        this.formData.name=info.name;
        this.formData.image=info.image;
        this.formData.start_at=info.start_at_date;
        this.formData.end_at=info.end_at_date;
        this.formData.description=info.description;
        this.formData.company_app_id=info.company_app_id;

      });
    },
    
    
    
    submit(){
      var that=this;
      
      this.$refs["form"].validate((valid) => {
          if (valid) {
            console.log(that.formData);
            if(that.formData.project_id){
              updateProject(that.formData).then((response) => {
                console.log(response);
                if(response.code==200){
                  this.$message({
                    message: "提交成功",
                    type: 'success'

                  });
                  that.$emit('refresh');
                  that.visible = false;
                
                }else{
                  this.$message({
                    message: response.message?response.message:"提交失败",
                  });
                }
              });

            }else{
              addProject(that.formData).then((response) => {
                console.log(response);
                if(response.code==200){
                  this.$message({
                    message: "提交成功",
                    type: 'success'

                  });
                  that.$emit('refresh');
                  that.visible = false;
                
                }else{
                  this.$message({
                    message: response.message?response.message:"提交失败",
                  });
                }
              });
            }
          } 
        });

    },

    
  },

 
};
</script>

<style lang="scss" scoped>
::v-deep .myWindow {
    border-radius: 15px;



.el-button--primary {
  color: #FFF;
  background-color: #717ebb;
  border-color: #717ebb;
}


/*
.footer{
  display: flex;
  justify-content: center;
}*/


  }
</style>
